import { Feed, CorporateFare, Home , PeopleAlt} from "@mui/icons-material";
import { USER_ROLES } from "../../utils/constants";
export const sidebarMenu = [
    {
        path: "/dashboard/home",
        name: "Home",
        icon : <Home/>,
        roles:[USER_ROLES.ORGANIZATION_ADMIN,USER_ROLES.STAFF, USER_ROLES.SUPER_ADMIN]
    },
    {
        path: "/dashboard/history",
        name: "History",
        icon : <Feed/>,
        roles:[USER_ROLES.ORGANIZATION_ADMIN,USER_ROLES.STAFF, USER_ROLES.SUPER_ADMIN]
    },
    {
        path: "/dashboard/organization",
        name: "Organization",
        icon : <CorporateFare/>,
        roles:[USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.SUPER_ADMIN]
    },
    {
        path: "/dashboard/users",
        name: "User",
        icon : <PeopleAlt/>,
        roles:[USER_ROLES.ORGANIZATION_ADMIN, USER_ROLES.SUPER_ADMIN]
    },
]